import styled from "styled-components";

export const PhotoAiReferenceModalStyled = styled.div`
  padding: 1.5rem;

  h2 {
    margin: 0 0 1rem;
    font-size: 1.125rem;
    color: #24272e;
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.75rem;
    margin-bottom: 1.25rem;
  }

  .thumb {
    border: 2px solid #e5e7eb;
    border-radius: 10px;
    overflow: hidden;
    padding: 0;
    background: #f9fafb;
    aspect-ratio: 1;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    &.active {
      border-color: #6d5bd0;
    }
  }

  .actions {
    display: flex;
    gap: 0.75rem;

    button {
      flex: 1;
      border: none;
      border-radius: 10px;
      padding: 0.75rem;
      font-size: 0.875rem;
      font-weight: 600;
      cursor: pointer;

      &.secondary {
        background: #f3f4f6;
        color: #374151;
      }

      &.primary {
        background: #6d5bd0;
        color: #ffffff;

        &:disabled {
          opacity: 0.55;
          cursor: default;
        }
      }
    }
  }
`;
